// Copyright (c) StrangeBee 2023

import { Button, Layout } from 'antd';
import React, { ReactElement, useState } from 'react';
import MainLayoutSiderFooter from '@Organisms/MainLayout/MainLayoutSiderFooter/MainLayoutSiderFooter';
import { ICONS } from '@Constants/iconsApp';

import './MainLayoutSider.scss';

interface MainLayoutSiderProps {
    menu?: ReactElement;
}

const { Sider } = Layout;

const MainLayoutSider = ({ menu }: MainLayoutSiderProps): ReactElement => {
    const [isMenuClosed, setIsMenuClosed] = useState<boolean>(true);

    return (
        <Sider collapsed={isMenuClosed} className="main-layout-sider" width="250">
            <div className="sider_part main-layout-sider__action">
                <Button
                    type="link"
                    onClick={(): void => setIsMenuClosed(!isMenuClosed)}
                    icon={isMenuClosed ? <ICONS.ArrowRightOutlined /> : <ICONS.ArrowLeftOutlined />}
                />
            </div>

            <div className="sider_part main-layout-sider__menu">
                {menu &&
                    React.cloneElement(menu, {
                        isMenuClosed,
                        setIsMenuClosed,
                    })}
            </div>

            <div className="sider_part main-layout-sider__about">
                <MainLayoutSiderFooter isMenuClosed={isMenuClosed} />
            </div>
        </Sider>
    );
};

export default MainLayoutSider;
